function findNested(path, data) {
    if(path.length === 0) {
        return null;
    }
    const nextParticle = path.splice(0, 1);
    if(!data.hasOwnProperty(nextParticle)) {
        return null;
    }

    const value = data[nextParticle];
    if(path.length === 0) {
        return value;
    }

    return findNested(path, value);
}

export function __(key) {
    if (!window.hasOwnProperty('__lang')) {
        return key;
    }
    return findNested(key.split('.'), window.__lang) ?? key;
}
